import type { HierarchyItem, HierarchyItemWithLevels } from '@openx/types/hierarchyItem.ts';

export const flattenWithLevels = (data: HierarchyItem[], level = 0): HierarchyItemWithLevels[] => {
  return data.flatMap(item => {
    const children = item.children || [];
    const currentItem: HierarchyItemWithLevels = {
      id: item.id,
      name: item.name,
      level,
    };

    const childrenItems = flattenWithLevels(children, level + 1);

    return [currentItem, ...childrenItems];
  });
};
